import classNames from "classnames";
import { useTranslations } from "../i18n";
import { ExportedView } from "./ExportedView"
import { ImageSize, setImageSize, SIZES } from "./exportSlice";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { renderToString } from "react-dom/server";
import { toPng } from "html-to-image";
import { RootState, store } from "../../app/store";
import { sanitizeName } from "../save-load/Buttons";
import { addMetadataFromBase64DataURI } from "meta-png";

export function ExportModal() {
    const t = useTranslations();
    const selectedSize = useAppSelector(state => state.export.imageSize);
    const [width, height] = SIZES[selectedSize];

    return <div className="export-modal">
        <h1>{t.saveAsImageModalTitle}</h1>

        <div className="export-preview">
            <div style={{ zoom: 700 / width }}>
                <ExportedView width={width} height={height} />
            </div>
        </div>

        <SizeSelect />

        <small><i>{t.exportHint}</i></small>

        <hr />

        <ExportButton />
    </div>
}

function SizeSelect() {
    const t = useTranslations();
    const selected = useAppSelector(state => state.export.imageSize);
    const dispatch = useAppDispatch();

    return <div>
        {t.size}:
        <div className="export-select">
            {Object.entries(SIZES).map(([name, [width, height]]) =>
                <div
                    key={name}
                    className={classNames("text-button", { "selected": name === selected })}
                    onClick={() => dispatch(setImageSize(name as ImageSize))}
                >
                    {t.sizes[name as ImageSize]}<br />
                    <small>({width}×{height})</small>
                </div>
            )}
        </div>
    </div>
}

function ExportButton() {
    const t = useTranslations();
    return <div className="text-button"
        onClick={async () => {
            const state = store.getState();
            const [width, height] = SIZES[state.export.imageSize];

            let png, root;
            try {
                root = document.createElement("div");
                root.innerHTML = renderToString(<ExportedView width={width} height={height} />);
                root.style.width = `${width}px`;
                root.style.height = `${height}px`;
                root.style.backgroundColor = "white";
                document.body.appendChild(root);

                png = await toPng(root);
            } finally {
                root?.remove();
            }

            const selectedState: Partial<RootState> = {};
            const selectedSlices = [
                "titles", "arguments", "language", "legend", "patternsActive", "export"
            ] as const satisfies (keyof RootState)[];
            for (const slice of selectedSlices) {
                selectedState[slice] = state[slice] as any;
            }

            let json = JSON.stringify(selectedState);
            // Escape non-ASCII characters -- meta-png doesn't like them
            // Taken/adjusted from here: https://stackoverflow.com/a/31652607
            json = json.replace(/[\u007F-\uFFFF]/g, c => "\\u" + ("0000" + c.charCodeAt(0).toString(16)).slice(-4))

            png = addMetadataFromBase64DataURI(png, "argumentationswippe", json);

            const link = document.createElement("a");
            link.download = `Argumentationswippe-${sanitizeName(state.titles.title)}.png`;
            link.href = png;
            link.click();
        }}
    >
        {t.downloadImage}
    </div>;
}
